<template>
    <div class="bg_F9F8F7 body_bg">
        <nav-bar :navigationIndex="3" />
        <div>
            <div class="top_bar bg_img flex">
                <div class="w_1280">
                    <div class="industry_news_title">产业新闻</div>
                    <div class="industry_news_en">INDUSTRY NEWS</div>
                </div>
            </div>

            <div class="project_detail_box bg_fff_box w_1280">
                <div class="font_size20 color_B5B5B5">
                    <span class="cursor" @click="goPage('/newsInformationPage')">产业新闻</span>>新闻详情
                </div>
                <div class="w_1280">
                    <div class="detail_title">
                        {{ articleDetails.title }}
                    </div>
                    <div class="flex_center">
                        <!-- <div class="detail_time">{{ articleDetails.createByName }}</div> -->
                        <div class="detail_time">发表时间：{{ articleDetails.publishTime }}</div>
                    </div>

                    <div v-html="renderedContent">
                    </div>

                    <!-- <div>
                        <el-divider v-if="articleDetails && articleDetails.fileList && articleDetails.fileList.length"
                            content-position="left">附件列表</el-divider>
                        <div v-for="(item, index) in articleDetails.fileList" :key="index">
                            <el-link :href="item.url" target="_blank">{{ item.fileName }}</el-link>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <bottom-bar></bottom-bar>
    </div>
</template>

<script>
import { articleInfo, getOutImgUrl } from "@/utils/newsApi";
// @ is an alias to /src

export default {
    components: {
    },
    data() {
        return {
            articleDetails: {},
            renderedContent: '',
        }
    },
    mounted() {
        if (this.$route.query.id) {
            let id = this.$route.query.id;
            this.getArticleInfo(id);
        }
    },
    methods: {
        // 文章详情
        async getArticleInfo(id) {
            let res = await articleInfo({ id: id });
            if (res.code == 200) {
              this.articleDetails = res.data || {};
              this.renderedContent = await this.replaceImageSrc(this.articleDetails.content || '');
            }
        },
        // 跳转页面
        goPage(path) {
            this.$router.push({
                path: path,
            });
        },
      async replaceImageSrc(content) {
        if (!content) {
          return '';
        }

        const imgRegex = /<img\b[^>]*\bdata-oss-id=["']([^"']+)["'][^>]*>/gi;
        const matches = [...content.matchAll(imgRegex)];

        if (!matches.length) {
          return content;
        }

        const urlMap = {};

        await Promise.all(matches.map(async (match) => {
          const ossId = match[1];
          if (!ossId || Object.prototype.hasOwnProperty.call(urlMap, ossId)) {
            return;
          }

          try {
            const response = await getOutImgUrl(ossId);
            urlMap[ossId] = response?.code === 200 ? (response.data || '') : '';
          } catch (error) {
            urlMap[ossId] = '';
          }
        }));

        return content.replace(imgRegex, (imgTag, ossId) => {
          const newSrc = urlMap[ossId];
          if (!newSrc) {
            return imgTag;
          }

          if (/\bsrc=["'][^"']*["']/i.test(imgTag)) {
            return imgTag.replace(/\bsrc=["'][^"']*["']/i, `src="${newSrc}"`);
          }

          return imgTag.replace('<img', `<img src="${newSrc}"`);
        });
      }
    }
}
</script>

<style scoped lang="scss">
.body_bg {
    background: url("@/assets/images/newsbg.png") center no-repeat;
    background-size: cover;
}

.bg_img {
    background: url("@/assets/images/newsBanner.png") center no-repeat;
    background-size: cover;
}

.top_bar {
    width: 100%;
    height: 509px;
}

.industry_news_title {
    font-weight: bold;
    font-size: 73px;
    color: #FFFFFF;
}

.industry_news_en {
    font-weight: 500;
    font-size: 23px;
    color: #FFFFFF;
}

.project_detail_box {
    padding-top: 80px;
    padding-bottom: 130px;
    margin-bottom: 66px;
}

.detail_title {
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    margin-top: 80px;
}

.detail_time {
    text-align: center;
    font-size: 20px;
    color: #313131;
    margin: 20px 45px 20px 45px;
}

:deep(.my-label) {
    background: #CDE5D9 !important;
    height: 58px;
    font-size: 20px;
    color: #313131;
}

:deep(.el-descriptions__body) {
    .el-descriptions__content.el-descriptions__cell.is-bordered-content {
        min-width: 444px;
        max-width: 444px;
        word-break: break-all; // 让内容超出列宽时自动换行显示
        word-wrap: break-word;
    }
}
</style>